import { render, staticRenderFns } from "./Cif.vue?vue&type=template&id=24affcd8"
import script from "./Cif.vue?vue&type=script&lang=js"
export * from "./Cif.vue?vue&type=script&lang=js"
import style0 from "./Cif.vue?vue&type=style&index=0&id=24affcd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports